export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return '';

  const path =
    typeof imagePath === 'string'
      ? imagePath
      : imagePath?.secure_url || imagePath?.url || imagePath?.public_id || '';

  if (!path) return '';

  // Already a full URL (Cloudinary or any external)
  if (path.startsWith('http')) {
    return path;
  }

  // Handle partial Cloudinary paths like 'image/upload/...'
  if (path.includes('image/upload/')) {
    return `https://res.cloudinary.com/dxoecm0tx/${path}`;
  }

  // Fallback for local images (if any)
  return `http://127.0.0.1:8000/${path}`;
  // return `https://backend-i9kq.onrender.com/${imagePath}`;

  // https://backend-i9kq.onrender.com/
};
